// 上传图片地址
export const uploadUrl = process.env.VUE_APP_BASE_API + '/file/upload/cos-books';
export const uploadFile = process.env.VUE_APP_BASE_API + '/wwqb/exam-paper/content/import';
export const uploadAudio = process.env.VUE_APP_BASE_API + '/file/upload/cos-audios';

// 图书资源上传地址
export const uploadBook = process.env.VUE_APP_BASE_API + '/file/upload/zip-book';

// 判断是否是"北京"  "题型专项训练"
export const isAddressType = {
  isAddressType: false
};

export const questionOptions = {
  questionOptions: [], // 题源
  options: [] // 地址
};

// textarea高度权重
export const textareaRows = {
  firstLevel: 1,
  secondLevel: 1,
  againLevel: 2,
  hearing: 3,
  subject: 1,
  option: 1,
  answer: 1,
  field: 1,
  icon: 1,
  topic: 3,
  keywords: 3,
  keypoint: 3,
  refanswer: 3
}

// 栏位
export const fieldsOptions = [
  {
    id: 1,
    name: 'firstLevel',
    value: "一级题干",
    label: "一级题干",
  },
  {
    id: 2,
    name: 'secondLevel',
    value: "二级题干",
    label: "二级题干",
  },
  {
    id: 3,
    name: 'againLevel',
    value: "三级题干",
    label: "三级题干",
  },
  {
    id: 4,
    name: 'audio',
    value: "材料音频",
    label: "材料音频",
  },
  {
    id: 13,
    name: 'hearing',
    value: "听力材料",
    label: "听力材料",
  },
  {
    id: 5,
    name: 'subject',
    value: "题目",
    label: "题目",
  },
  {
    id: 6,
    name: 'option',
    value: "选项",
    label: "选项",
  },
  {
    id: 7,
    name: 'answer',
    value: "答案",
    label: "答案",
  },
  {
    id: 9,
    name: 'chart',
    value: "图表",
    label: "图表",
  },
  {
    id: 10,
    name: 'topic',
    value: "topic",
    label: "topic",
  },
  {
    id: 11,
    name: 'keywords',
    value: "keywords",
    label: "keywords",
  },
  {
    id: 12,
    name: 'keypoint',
    value: "keypoint",
    label: "keypoint",
  },
  {
    id: 14,
    name: 'number_replace',
    value: "number_replace",
    label: "number",
  },
  {
    id: 15,
    name: 'analysis',
    value: "解析",
    label: "解析",
  },
  {
    id: 8,
    name: 'field',
    value: "栏位名称",
    label: "栏位名称",
  },
]

// 题目编号
export const questionNumber = [
  {
    id: 1,
    label: "一",
    children: [
      {
        id: 2,
        label: "Ⅰ",
        children: [
          {
            id: 3,
            label: "1",
          },
          {
            id: 4,
            label: "2",
          },
          {
            id: 5,
            label: "3",
          },
          {
            id: 6,
            label: "4",
          },
          {
            id: 7,
            label: "5",
          }
        ],
      },
      {
        id: 8,
        label: "Ⅱ",
        children: [
          {
            id: 9,
            label: "6",
          },
          {
            id: 10,
            label: "7",
          },
          {
            id: 11,
            label: "8",
          }
        ]
      },
    ],
  },
  {
    id: 12,
    label: "二",
    children: [
      {
        id: 13,
        label: "Ⅰ",
        children: [
          {
            id: 14,
            label: "9",
          },
          {
            id: 15,
            label: "10",
          },
          {
            id: 16,
            label: "11",
          },
          {
            id: 17,
            label: "12",
          },
          {
            id: 18,
            label: "13",
          }
        ],
      },
      {
        id: 19,
        label: "Ⅱ",
      },
    ],
  },
  {
    id: 20,
    label: "三"
  },
  {
    id: 21,
    label: "四",
    children: [
      {
        children: [
          {
            id: 22,
            label: "14",
          },
          {
            id: 23,
            label: "15",
          },
          {
            id: 24,
            label: "16",
          },
          {
            id: 25,
            label: "17",
          },
          {
            id: 26,
            label: "18",
          },
          {
            id: 27,
            label: "19",
          },
          {
            id: 28,
            label: "20",
          }
        ]
      }
    ]
  },
]
